import { Injectable } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, filter } from 'rxjs/operators';

import { ClientActions } from '../actions/client.actions';
import { ContextActions } from '../actions/context.actions';

@Injectable()
export class AppClientEffects {
  // Effects
  userClients$;
  selectInitialClient$;
  /**
   * Clear clients when the user becomes unauthenticated.
   */
  clearLoggedInUsersClients$;

  constructor(actions$: Actions, store: Store, auth: AuthService) {
    this.clearLoggedInUsersClients$ = createEffect(() => {
      return auth.isAuthenticated$.pipe(
        filter((isAuthenticated) => !isAuthenticated),
        map(() => ClientActions.clear()),
      );
    });

    this.userClients$ = createEffect(() => {
      return actions$.pipe(
        ofType(ContextActions.loadSuccess),
        map((action) =>
          ClientActions.addClients({
            clients: action.initialAppContext.clients,
          }),
        ),
      );
    });

    this.selectInitialClient$ = createEffect(() => {
      return actions$.pipe(
        ofType(ContextActions.loadSuccess),
        filter(
          (action) =>
            !action.initialAppContext.resellerContextSwitchable &&
            action.initialAppContext.clients.length === 1,
        ),
        map((action) =>
          ClientActions.selectClient({
            client: action.initialAppContext.clients[0].id,
          }),
        ),
      );
    });
  }
}
